import history from "./history";
import configureStore from "./store";

const saveTosessionStorage = (state) => {
  try {
    sessionStorage.setItem("state", JSON.stringify(state));
  } catch (e) {
    console.error(e);
  }
};

const loadFromsessionStorage = () => {
  try {
    const stateStr = sessionStorage.getItem("state");
    return stateStr ? JSON.parse(stateStr) : undefined;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

const persistedStore = loadFromsessionStorage();

export const store = configureStore(persistedStore, history);

store.subscribe(() => {
  saveTosessionStorage(store.getState());
});

export const storeDispatch = store.dispatch;
